import { Component } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  email: string;
  errorMessage: any;
  constructor(public authService: AuthService, private router: Router) {}

  resetPassword(email: string) {
    // console.log('Test mail: ', email);
    this.authService
      .resetPassword(email)
      .then(() => this.router.navigate(['/send-confirm']))
      .catch(error => (this.errorMessage = error));
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/forgot-password/forgot-password.component.ts